var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.905 14.617L25.3512 7H23.5869L17.1184 13.6124L11.9558 7H6L13.8086 17L6 24.9869H7.76429L14.591 18.0024L20.0442 24.9869H26L17.905 14.617ZM15.4877 17.0877L14.6954 16.0914L8.40053 8.17046H11.1108L16.1925 14.5652L16.9815 15.5616L23.5861 23.8734H20.8758L15.4877 17.0877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter3);
export default __webpack_public_path__ + "static/media/footer3.64b531a78eed7c2f930bb32fb6ce1dcb.svg";
export { ForwardRef as ReactComponent };